import React from 'react';

const knownResolutions = [
    { name: 'nHD', width: 640, height: 360 },
    { name: 'FWVGA', width: 854, height: 480 },
    { name: 'qHD', width: 960, height: 540 },
    { name: 'WSVGA', width: 1024, height: 576 },
    { name: 'HD/WXGA - 720p', width: 1280, height: 720 },
    { name: 'FWXGA', width: 1366, height: 768 },
    { name: 'HD+', width: 1600, height: 900 },
    { name: 'Full HD - 1080p', width: 1920, height: 1080 },
    { name: 'QWXGA', width: 2048, height: 1152 },
    { name: 'WQHD', width: 2560, height: 1440 },
    { name: 'QHD+', width: 3200, height: 1800 },
    { name: '4K UHD', width: 3840, height: 2160 },
    { name: '5K', width: 5120, height: 288 },
    { name: '8K UHD', width: 7680, height: 4320 },
].reduce((dict, res) => {
    dict[`${res.width} x ${res.height}`] = res;
    return dict;
}, {});

console.log(knownResolutions);

export const resolutionList = (maxWidth, maxHeight, selectedResolution) => {
    console.log(maxWidth);
    console.log(maxHeight);

    const options = Object.entries(knownResolutions).map(([k, v]) => <option key={k}
        value={k}
        disabled={v.width > maxWidth || v.height > maxHeight}
    >
        {k} ({v.name})
    </option>);

    if (!knownResolutions[selectedResolution]) {
        options.push(
            <option key={selectedResolution} value={selectedResolution}>
                {selectedResolution} (Custom)
            </option>);
    }

    return options;
}
